import moment from 'moment';

/**
 * Expiry-based daily storage
 *
 * This ensures the lock is only authorized once a day
 */
class DailySessionStorage {
  private expiryFromMemory?: number;

  constructor(private key: string) {}

  private getExpiry() {
    if (this.expiryFromMemory) return this.expiryFromMemory;
    const expiryFromStorage = Number(localStorage.getItem(this.key));
    if (!expiryFromStorage || Number.isNaN(expiryFromStorage)) return null;
    this.expiryFromMemory = expiryFromStorage;
    return expiryFromStorage;
  }

  private setExpiry() {
    const date = moment().add(1, 'day').startOf('day');
    this.expiryFromMemory = date.valueOf();
    localStorage.setItem(this.key, String(this.expiryFromMemory));
  }

  public authorize() {
    const expiry = this.getExpiry();
    if (!expiry) {
      this.setExpiry();
      return true;
    }

    const currentTime = new Date().getTime();
    const result = expiry - currentTime < 0;
    if (result) {
      this.setExpiry();
      return true;
    }
    return false;
  }
}

export default DailySessionStorage;
